import axiosInstance from '../api';
import { 
  RecordWatchReq,
  RecordWatchRes,
  WatchRecordByVideoIdRes
} from './watchRecordApi.types';

/**
 * 視聴記録を作成または更新する
 */
export const recordWatch = async (data: RecordWatchReq): Promise<RecordWatchRes> => {
  const response = await axiosInstance.post<RecordWatchRes>('/watch-records', data);
  return response.data;
};

/**
 * ユーザーの特定動画に対する最新視聴記録を取得
 */
export const fetchWatchRecordByVideoId = async (videoId: string): Promise<WatchRecordByVideoIdRes> => {
  const response = await axiosInstance.get<WatchRecordByVideoIdRes>(`/watch-records/video/${videoId}`);
  return response.data; // レコードが無い場合は null
}; 